const TenderTypeList = ({ data, onEdit, onToggle, loading }) => {
    return (
        <div className="admin-table-wrapper">
            <table className="admin-table">
                <thead>
                    <tr>
                        <th className="col-sr">Sr</th>
                        <th>Tender Type</th>
                        <th className="col-status">Status</th>
                        <th className="col-actions">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {loading && (
                        <tr>
                            <td colSpan="4" className="text-center">Loading...</td>
                        </tr>
                    )}

                    {!loading && data.length === 0 && (
                        <tr>
                            <td colSpan="4" className="text-center">
                                No Departments Found
                            </td>
                        </tr>
                    )}

                    {!loading &&
                        data.map((d, i) => (
                            <tr key={d.id}>
                                <td className="col-sr">{i + 1}</td>
                                <td>{d.tenderTypeName}</td>
                                <td>
                                    <span className={d.active ? "status-active" : "status-inactive"}>
                                        {d.active ? "Active" : "Inactive"}
                                    </span>
                                </td>
                                <td>
                                    <div
                                        className="admin-action-edit">
                                        <span className="act-1" onClick={() => onEdit(d)}>Edit Details</span>{" / "}
                                        <span className="act-2" onClick={() => onToggle(d)} >{d.active ? "Deactivate" : "Activate"}</span>
                                    </div>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    )
}

export default TenderTypeList;